export const plan = {
    labels: {
        affiliate_accounts: "Contas Afiliadas",
        plan: "Plano",
        plans: "Planos",
        invoice: "Fatura",
        invoices: "Faturas",
        my_account: "Minha Conta",
        my_plans: "Meus Planos",
        my_signature: "Minha Assinatura",
        my_invoices: "Minhas Faturas",
        frequency: "Frequência (em dias)",
        frequency_short: "Frequência",
        plan_edit: "Editar Plano",
    },
    modals: {
        titles: {
            plan_add: "Adicionar Plano",
            plan_remove: "Remover Plano",
        },
        messages: {
            plan_remove: "Tem certeza que deseja remover o plano <strong>{name}</strong>?<br/>Essa ação não pode ser desfeita.",
        }
    },
    texts: {
        account_empty: "Você ainda não tem uma conta.",
        affiliate_accounts: "Você ainda não tem acesso a outras contas.",
        invoice_empty: "Você ainda não tem faturas.",
        signature_empty: "Você ainda não tem uma assinatura.",
    },
};
